<template>
  <dialog-zoomer :visible="viz" v-on:close="handleClose">
    <div class="news-pop">
      <div class="close-box grey" v-on:click="handleClose"></div>
      <news-story :newsid="nid" v-on:load="handleLoaded" />
    </div>
  </dialog-zoomer>
</template>

<script>
import DialogZoomer from '@/components/dialogs/DialogZoomer.vue'
import NewsStory from './NewsStory.vue'

export default {
  components: {
    DialogZoomer,
    NewsStory
  },
  props: {
    newsid: String,
    value: Boolean
  },
  data () {
    return {
      viz: false,
      nid: '0'
    }
  },
  created () {
    this.nid = this.newsid
  },
  methods: {
    handleClose () {
      this.viz = false
      this.$emit('input', false)
      this.$emit('close')
    },
    handleLoaded () {
      console.log('got loaded')
      this.viz = true
    }
  },
  watch: {
    newsid () {
      this.viz = true
      console.log('newsid is', this.newsid)
      this.nid = this.newsid
    },
    value () {
      if(this.value) {
        this.viz = true
      }
      else {
        this.viz = false
      }
    }
  }
  
}
</script>

<style>
.ntimage{
  opacity:0;
  transition:opacity 0.4s linear;
}

.ntimage.loaded{
  opacity:1;
}



.news-pop{
  padding:45px 45px 0 45px;
  background-color:#fff;
  max-height:95vh;
  width:90vw;
  max-width:1520px;
  overflow-y:auto;
  box-sizing:border-box;
  cursor:default;
}


@media screen and (max-width:640px) {
  .news-pop{
    padding:10px 10px 0 10px;
    width:98vw;
  }

}
</style>